module.exports = __webpack_public_path__ + "static/media/camera.d6e8ef9e.svg";